import { useTranslation } from 'react-i18next';
import { FixedCtaBanner } from 'components/FixedBanner';
import ScreenerResultSections from 'domains/signup/screener/Components/ScreenerResultsSummary/Sections';
import { ScreenerResultsCtx } from 'domains/signup/screener/Components/ScreenerResultsSummary/context';
import { ScreenerResults } from 'domains/signup/screener/data/results';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { identifyScreenerLDUser } from 'domains/signupDirect/misc/launchDarklyTracking';
import { useEffectOnce } from 'react-use';

export type ScreenerResultSummaryProps = {
  results: ScreenerResults;
  onProceedToSchedule: () => void;
};

export const ScreenerResultSummary: React.FC<ScreenerResultSummaryProps> = ({ onProceedToSchedule, results }) => {
  const { t } = useTranslation();

  const LDClient = useLDClient();
  useEffectOnce(() => {
    if (LDClient) {
      identifyScreenerLDUser(LDClient, {
        isTherapyRecommended: results.recommendEvaluation,
      });
    }
  });

  return (
    <div className="flex flex-col gap-64 mb-128 lg-d:mb-[200px]">
      <FixedCtaBanner onClickCTA={onProceedToSchedule} buttonText={t('screener.results.fixedBanner.cta')}>
        {t('screener.results.fixedBanner.title')}
      </FixedCtaBanner>
      <ScreenerResultsCtx.Provider
        value={{
          onProceedToSchedule,
          results,
        }}
      >
        <ScreenerResultSections.Intro />
        <ScreenerResultSections.Schedule />
        <ScreenerResultSections.Questions />
        <ScreenerResultSections.NextSteps />
        <ScreenerResultSections.FAQ />
        <ScreenerResultSections.PDF />
      </ScreenerResultsCtx.Provider>
    </div>
  );
};
